import { FooterStoreLogo } from "@components/layout/footer";
import { StarIcon } from "@heroicons/react/20/solid";
import DownloadCtaPhoneVertical from "@public/download-cta-phone-vertical.png";

const LandingDownloadBanner = () => {
  return (
    <div className="flex flex-col items-center pt-12">
      <div className="relative hidden sm:block">
        <LandingDownloadBannerWide />
      </div>

      <LandingDownloadBannerCompact />

      <LandingDownloadCtaContent />
    </div>
  );
};

enum LandingDownloadStarRatingPositionEnum {
  row,
  column,
}

interface ILandingDownloadStarRatingsProps {
  showStarRating?: boolean;
  starRatingPosition?: LandingDownloadStarRatingPositionEnum;
}

const LandingDownloadStarRatings: React.FC<
  ILandingDownloadStarRatingsProps
> = ({
  showStarRating = true,
  starRatingPosition = LandingDownloadStarRatingPositionEnum.row,
}) => {
  const rating = 4.7;
  const fullStars = Math.floor(rating);
  const partialFill = (rating % 1) * 100;

  return (
    <>
      <div
        className={classNames(
          "flex items-center gap-2",
          starRatingPosition === LandingDownloadStarRatingPositionEnum.row
            ? "flex-row"
            : "flex-col"
        )}
      >
        <div className="flex items-center gap-1">
          {Array.from({ length: 5 }).map((_, index) => {
            const fill =
              index < fullStars ? 100 : index === fullStars ? partialFill : 0;

            return (
              <div key={index} className="relative h-4 w-4">
                <StarIcon className="h-4 w-4 text-gray-300" />
                {fill > 0 && (
                  <div
                    className="absolute inset-0 overflow-hidden"
                    style={{ width: `${fill}%` }}
                  >
                    <StarIcon className="h-4 w-4 text-[#F39A14]" />
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {showStarRating && (
          <p>
            <span className="mr-2"></span>
            <span className="font-poppins text-sm font-semibold text-text-darkest">
              4.7
            </span>
            <span className="font-poppins text-sm text-text-dark">/5.0</span>
          </p>
        )}
      </div>
    </>
  );
};

const LandingDownloadCtaContent = () => {
  return (
    <div className="my-8 flex flex-col items-center gap-y-2">
      <p className="font-poppins text-lg font-bold text-text-darkest">
        <Trans>The only news app you need.</Trans>
      </p>

      <LandingDownloadStarRatings
        showStarRating={true}
        starRatingPosition={LandingDownloadStarRatingPositionEnum.row}
      />
      <p className="text-center font-poppins text-text-medium">
        <Trans>🥇 #1 on Google Play charts for News & Magazines</Trans>
      </p>
      <div className="mt-4">
        <FooterStoreLogo
          forceRow={true}
          customLogoClassName={
            "relative h-[32px] w-[108px] cursor-pointer overflow-hidden rounded-lg"
          }
        />
      </div>
    </div>
  );
};

const LandingDownloadBannerCompact = () => {
  return (
    <div className="relative mx-auto block aspect-[0.56] w-full max-w-[350px] rounded-3xl bg-primary sm:hidden">
      <div className="absolute inset-x-0 inset-y-10 z-20 flex justify-center">
        <p className="px-10 text-center font-poppins text-3xl font-bold text-white">
          Use Malaysia's #1 news app
        </p>
      </div>
      <div className="absolute inset-0 z-10 flex justify-center">
        <Image
          src={DownloadCtaPhoneVertical}
          alt=""
          className="h-auto w-auto"
        />
      </div>
    </div>
  );
};

import DownloadCtaBackground from "@public/download-cta-background.png";
import DownloadCtaPhone from "@public/download-cta-phone.png";
import DownloadCtaShadow from "@public/download-cta-shadow.png";
import Image from "next/image";
import { Trans } from "@lingui/macro";
import classNames from "@lib/classNames";

const LandingDownloadBannerWide = () => {
  return (
    <>
      <Image
        src={DownloadCtaBackground}
        alt=""
        className="block h-auto w-full"
      />

      <div className="pointer-events-none absolute inset-0 z-10 -translate-y-[12%]">
        <Image src={DownloadCtaShadow} alt="" className="block h-auto w-full" />
      </div>

      <div className="absolute inset-0 z-20 grid grid-cols-3 items-center">
        <div className="px-8 text-right md:pr-12 lg:pr-16">
          <p className="font-poppins text-2xl font-bold text-white lg:text-3xl">
            Use Malaysia's
          </p>
        </div>

        <div />

        <div className="px-8 text-left md:pl-12 lg:pl-16">
          <p className="font-poppins text-2xl font-bold text-white lg:text-3xl">
            #1 news app
          </p>
        </div>

        <div className="pointer-events-none absolute inset-x-0 bottom-[5px] z-20 flex justify-center pl-8 lg:pl-10">
          <Image src={DownloadCtaPhone} alt="" className="h-auto w-auto" />
        </div>
      </div>
    </>
  );
};

export default LandingDownloadBanner;
export { LandingDownloadStarRatings };
